import type { QueryClient, QueryKey } from "@tanstack/react-query";
/** Tamanhos compartilhados pelas listas do Configuration Server. */
export const LIST_PAGE_SIZE = 30;
export const PANEL_PAGE_SIZE = 15;
export const LIST_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
} as const;

/** Ramos fechados não releem ao montar: uma alteração descarta seu cache antigo. */
export function invalidateConfigQueries(
  client: QueryClient,
  queryKey: QueryKey,
) {
  client.removeQueries({ queryKey, type: "inactive" });
  return client.invalidateQueries({ queryKey });
}
